var map = {
	"./KategorieA": [
		283621,
		75031,
		2129,
		97179
	],
	"./KategorieA.tsx": [
		283621,
		75031,
		2129,
		97179
	],
	"./KategorieB": [
		181028,
		75031,
		2129,
		19164
	],
	"./KategorieB.tsx": [
		181028,
		75031,
		2129,
		19164
	],
	"./ProductPageTemplate": [
		360363,
		75824,
		39423,
		82070
	],
	"./ProductPageTemplate.tsx": [
		360363,
		75824,
		39423,
		82070
	],
	"./ProductsPageTemplate": [
		921707,
		96995
	],
	"./ProductsPageTemplate.tsx": [
		921707,
		96995
	],
	"./WissenArticlePage": [
		401355,
		75031,
		162
	],
	"./WissenArticlePage.tsx": [
		401355,
		75031,
		162
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 452644;
module.exports = webpackAsyncContext;